import axios, { HttpStatusCode } from "axios";

export const BASE_URL = process.env.REACT_APP_ADDMIX_STORE_API_BASE_URL || "http://localhost:8080";
// export const BASE_URL ="http://localhost:8080";


export const apiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, //important for cookies
  headers: {
    "Content-Type": "application/json"
  }
});

// Request interceptor: attach access token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const lang = getLanguage();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["Accept-Language"] = lang; // to ensure that the lang will be sent if the default headers are removed after refreshing the page
    return config;
  },
  (error) => Promise.reject(error)
);

// Flag to avoid multiple refresh calls in parallel
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
      error ? prom.reject(error) : prom.resolve(token);
  });
  failedQueue = [];
};

// Response interceptor: handle 401 and retry
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest?.url?.includes("/api/auth/refresh")) {
      return Promise.reject(error);
    }

    // If 401, try refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // queue requests until refresh finishes
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return apiClient.request(originalRequest);
        });
          // .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // delete old token
        delete apiClient.defaults.headers.common["Authorization"];
        // call refresh endpoint (cookie auto-sent)
        const res = await apiClient.post("/api/auth/refresh", {}, { withCredentials: true });

        const newToken = res.data.accessToken;

        localStorage.setItem("token", newToken);
        localStorage.setItem("token", newToken);
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

        processQueue(null, newToken);

        // retry failed request with new token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return apiClient.request(originalRequest);
      } catch (err) {
        processQueue(err, null);

        // refresh failed → clear & redirect
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/auth";

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// helper to add custom headers
export const addKeyToInterceptorConfigHeaders = (key, value) => {
  if (key && value) {
    apiClient.interceptors.request.use(config => {
      config.headers[key] = value;
      return config;
    });
  }
};


// get current language
export const getLanguage = () => {
  return localStorage.getItem("lang") || "en";
};